import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SubscriptionList } from '@vendasta/rx-utils';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { SearchbarService } from './searchbar.service';

@Component({
  selector: 'sales-ui-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: [],
  standalone: false,
})
export class SearchbarComponent implements OnInit, OnDestroy {
  @Input() i18nPlaceholderToken: string;

  readonly currentTerm$: Observable<string> = this.store.searchTerm$.pipe(startWith(''));
  readonly searchCtrl = new UntypedFormControl();
  private readonly subscriptions: SubscriptionList = SubscriptionList.new();

  constructor(private readonly store: SearchbarService) {}

  ngOnInit(): void {
    this.subscriptions.add(this.searchCtrl.valueChanges, (change: string) => this.store.setSearchTerm(change));
  }

  ngOnDestroy(): void {
    this.subscriptions.destroy();
  }
}
